import React, { FC } from 'react';
import { ScheduleParams, ScheduleResponse } from 'api/post';
import List from 'components/workflowOptions/postsSelection/posts/List';
import style from './postSchedulingResults/PostsSchedulingResults.module.scss';
import { PostDetail } from 'types/PostDetail';
import { STATUS } from '@kontentino/kontentino-constants/Posts';

type Props = {
  scheduleResponse: ScheduleResponse;
  scheduleChosenMethod?: ScheduleParams['chosenMethod'];
  posts: PostDetail[];
};

const PostsSchedulingResults: FC<Props> = ({
  scheduleResponse,
  posts,
  scheduleChosenMethod,
}) => {
  function getScheduledPosts() {
    return posts
      .filter((post) => !!scheduleResponse?.[post.id])
      .map((post) => ({
        ...post,
        status: scheduleResponse?.[post.id].status
          ? scheduleChosenMethod === 'export'
            ? STATUS.EXPORTED
            : STATUS.SCHEDULED
          : post.status,
      }));
  }

  function getWarningMessages() {
    return Object.fromEntries(
      Object.entries(scheduleResponse).map(([key, value]) => [
        key,
        value.message || (typeof value.data === 'string' ? value.data : ''),
      ]),
    );
  }

  const scheduledPosts = getScheduledPosts();
  const warningMessages = getWarningMessages();

  return (
    <List
      className={style.postSchedulingResults}
      posts={scheduledPosts}
      warningMessages={warningMessages}
      selectedPosts={scheduledPosts}
      onSelectPost={() => null}
    />
  );
};

export default PostsSchedulingResults;
